/**
 * Interação que a pessoa não iniciou.
 *
 * Quando um plano de consulta termina, o agente registra sozinho a resposta
 * consolidada como uma interação normal da conversa — com `interacao_id`
 * próprio, envelope de turno e 👍/👎 —, mas sem pergunta: `pergunta: null` e
 * `origem: "consolidacao_do_plano"` (§7.5 do spec do nível B v2). Quem desenha
 * a conversa (o F5, a transcrição relida, o histórico) pula a bolha da pessoa
 * nesse caso: inventar uma pergunta seria atribuir à pessoa o que ela não disse.
 *
 * Fica no domínio, sem dependência, porque o cliente HTTP e o cartão de
 * conversa relida precisam da MESMA regra, e um importa o outro.
 */

/** A `origem` da resposta consolidada de um plano de consulta. */
export const ORIGEM_DA_CONSOLIDACAO_DO_PLANO = 'consolidacao_do_plano'

/**
 * Sem fala da pessoa: a consolidação de um plano, ou qualquer interação cuja
 * pergunta não chegou como texto. Turno comum (`origem: null`) com pergunta
 * segue com a bolha dela.
 */
export function interacaoSemPergunta (
  interacao: { pergunta?: string | null, origem?: string | null }
): boolean {
  return interacao.origem === ORIGEM_DA_CONSOLIDACAO_DO_PLANO ||
    typeof interacao.pergunta !== 'string' || !interacao.pergunta.trim()
}
